import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../../Button';
import Title from '../../../Title';
import { sendingIdPhoto } from '../../../../services/backendService';
import { getUserDetails } from '../../../../reducers/userDetails';
import { getAuthToken } from '../../../../reducers/auth';
import { geti18n } from '../../../../reducers/i18n';
import { SmallError } from '../../../InputError';
class PhotoIdUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileToUpload: null,
      stateSendingPhoto: null
    };
    this.continue = this.continue.bind(this);
  }

  handleFileSelected = event => {
    const fileToUpload = event.target.files[0];
    const memberId = this.props.userDetails.get('data').get('id');
    const token = this.props.token;
    this.setState({ stateSendingPhoto: 'inProgress' });
    sendingIdPhoto(memberId, fileToUpload, token)
      .then(() => this.setState({ stateSendingPhoto: 'ok' }))
      .catch(e =>
        this.setState({
          stateSendingPhoto: 'error',
          cause: e === 'file-too-big' ? 'onboarding.photoIdUpload.fileTooBig' : 'onboarding.photoIdUpload.PhotoError'
        })
      );
    if (fileToUpload) {
      const reader = new FileReader();
      reader.onload = event => {
        this.setState({
          fileToUpload: event.target.result,
          invalidPhoto: null,
          empty: false
        });
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  continue(event) {
    event.preventDefault();
    if (this.state.fileToUpload !== null) {
      this.props.next();
    } else {
      this.setState({ empty: true });
    }
  }

  render() {
    const { stateSendingPhoto, cause } = this.state;
    const i18n = this.props.i18n;
    const errorPhotoId = this.state.stateSendingPhoto === 'error' ? <SmallError message={i18n(cause)} /> : null;
    const photo = this.state.fileToUpload ? (
      <div>
        <div className="photo-id-upload__upload-box__img-mask" />
        <img alt="photoId" src={this.state.fileToUpload} className="photo-id-upload__upload-box__img" />
      </div>
    ) : (
      <div className="photo-id-upload__upload-box__img" />
    );
    const classPhotoText = this.state.fileToUpload ? 'photo-id-upload__upload-box__text' : '';
    const classError = this.state.empty ? 'photo-id-upload__upload-box__text-error' : '';
    const photoText = this.state.fileToUpload ? i18n('onboarding.photoIdUpload.textOnPhotoUploaded') : i18n('onboarding.photoIdUpload.textOnPhoto');
    return (
      <div className="photo-id-upload text-center">
        <Title text={i18n('onboarding.photoIdUpload.title')} className="form__title" />
        <div className="row justify-content-center">
          <div className="col-sm-7">
            <p className="form__description mb-5">{i18n('onboarding.photoIdUpload.description')}</p>
          </div>
        </div>
        <div className={`mx-auto mb-5 photo-id-upload__upload-box ${this.state.empty ? 'photo-id-upload__upload-box-error' : ''}`}>
          <input id="photo-id" type="file" accept="image/*" onChange={this.handleFileSelected} />
          <label htmlFor="photo-id" className="photo-id-upload__upload-box__label">
            {photo}
            <p className={`form__textFile ${classPhotoText} ${classError}`}>{photoText}</p>
          </label>
        </div>
        {errorPhotoId}
        <Button
          disabled={stateSendingPhoto !== 'ok'}
          onClick={this.continue}
          text={stateSendingPhoto === 'inProgress' ? i18n('onboarding.photoIdUpload.pending') : i18n('onboarding.photoIdUpload.buttonText')}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userDetails: getUserDetails(state),
  token: getAuthToken(state),
  i18n: geti18n(state)
});

export default connect(mapStateToProps)(PhotoIdUpload);



// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/PhotoIdUpload.js